import "./CaseStudies.css";
import img1 from "../../assets/image/1.webp";
import img2 from "../../assets/image/2.webp";
import img3 from "../../assets/image/3.webp";
import "../../assets/css/style.css"
const caseData = [
  {
    img: img1,
    title: "PicOS Switch Software",
    desc:
      "Disaggregated NOS built on industry-standard Debian Linux seamlessly integrates into any network environment.",
  },
  {
    img: img2,
    title: "AmpCon Management Platform",
    desc:
      "Deploy, orchestrate, and manage data center and campus networks at scale with automated workflows.",
  },
  {
    img: img3,
    title: "PicOS-V Virtual Operating System",
    desc:
      "Prototype network ops, validate configuration, and test features with PicOS-V.",
  },
];

export default function CaseStudies() {
  return (
    <section className="case-studies py-5">
      <div className="container">
      <h2
  className="text-center mb-4"
  style={{ color: "#fff" }}
>
  Case Studies
</h2>

        <div className="row g-4">
          {caseData.map((item, index) => (
            <div className="col-md-4" key={index}>
              <div className="cs-card">
                {/* IMAGE ONLY */}
                <div className="cs-img">
                  <img src={item.img} alt={item.title} />
                </div>

                <div className="cs-body">
                  <h6>{item.title}</h6>
                  <p>{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
